// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application--is-ltr .v-data-table__mobile-row__cell[data-v-fd8d8e64]{text-align:left}tr td[data-v-fd8d8e64]{min-height:80px;height:80px!important}tr[data-v-fd8d8e64]:hover{background:unset!important}tr th[data-v-fd8d8e64]{color:#1e232c!important}", ""]);
// Exports
module.exports = exports;
